import {useQuery} from '@tanstack/react-query';
import useRestAPI from './useRestAPI';
import useQueryState from './useQueryState';
import {useCountryParam} from './useCountryParam';
import {endpoints} from '../services/endpoints';
import {config} from '../config';
import type {Banner} from '../api/customer-frontend-service/Banner';

export const useBanner = () => {
  const api = useRestAPI();
  const {country} = useCountryParam();
  const [dismissedId, setDismissedId] = useQueryState<string | null>(
    ['banner-dismissed'],
    null,
  );

  const query = useQuery({
    queryKey: ['banner', country.code] as const,
    retry: false,
    queryFn: async () => {
      const url = endpoints.banner.getBanner.build({
        query: {country: country.code, platform: config.clientPlatform},
      });
      return (await api.client.getJSONBody<Banner>(url)) ?? null;
    },
  });

  const dismiss = () => setDismissedId(query.data?.id ?? null);

  return {
    banner: query.data,
    show: Boolean(query.data?.title) && query.data?.id !== dismissedId,
    dismiss,
  };
};

export default useBanner;
